export enum BcmTenantPermission {
    ACCOUNTING_B2B = 'accounting_b2b',
    PERSONS = 'persons',
    ORGANISATIONS = 'organisations',
    TENANT_RELATIONS = 'tenant_relations',
    PRODUCTS = 'products',
    BOATS = 'boats',
    VISUAL_BERTH_PLAN = 'visualBerthPlan',
    BERTH = 'berths',
    BERTHS_TABLE = 'berths_table',
    BERTHS_PIERS = 'berths_piers',
    WINTER_STORAGES = 'winter_storages',
    BERTH_SCHEDULER = 'berths_scheduler',
    CASH = 'cash',
    ELECTRIC_METERS = 'electric_meters',
    INVOICES = 'invoices',
    INVOICES_MARK_AS_PAID = 'invoices_mark_as_paid',
    INVOICE_COLLECTION = 'invoice_collection',
    QUOTES = 'quotes',
    INVOICE_MAILING = 'invoice_mailing',
    IMPORTDATA = 'import',
    DATEV = 'datev',
    XDOC_EXPORT = 'bcm_xdoc_export',
    SEPA = 'sepa',
    MESSAGES_EMAIL = 'messages_mail',
    CONTRACT_MANAGER = 'contract_manager',
    REPORTS = 'reports',
    ASSOCIATION_REPORTS = 'association_reports',
    ROLES_PERMISSIONS = 'roles_permissions',
    DOCUMENTS_MANAGEMENT = 'documents_management',
    KEYS = 'keys',
    SEASONS = 'seasons',
    BANK = 'bank',
    DOCKSITE = 'docksite',
    DOCKSITE_CASH = 'docksite_cash',
    DOCKSITE_ORDERS = 'docksite_orders',
    DOCKSITE_CRANE = 'docksite_crane',
    DOCKSITE_SLIP_VOUCHER = 'docksite_slip_voucher',
    DOCKSITE_WORKING_TIME = 'docksite_working_time',
    DATA_RESTORE = 'data-restore',
    NEWS = 'news',
    COST_CENTERS = 'cost_centers',
    DEPARTMENTS = 'departments',
    EMPLOYEES = 'employees',
    WORKING_TIME_MANAGEMENT = 'working_time_management',
    ONLINE_BERTH_BOOKING = 'bcm_online_berth_booking',
    EXTERNAL_BERTH_BOOKINGS = 'bcm_external_berth_bookings',
    ELECTRIC_METER_API = 'bcm_electric_meter_api',
    SYSKA_EXPORT = 'bcm_syska_export',
    BEER_MAT_EXPORT = 'beer_mat_export',
    PIN_CODES = 'pin_codes',
    ARRIVAL_DEPARTURE = 'arrival_departure',
    REGULAR_BOAT_INSPECTIONS = 'regularBoatInspections',
    BERTH_ABSENCES = 'berth_absences',
    WATER_LEVEL = 'water_level',
    RECEIPT_WORD_DESIGNER = 'receipt_word_designer',
    BERTH_VOUCHER = 'berth_voucher',
    DYNAMIC_PRICING = 'dynamic_pricing',
    ABO_INVOICE_SCHEDULER = 'abo_invoice_scheduler',    
    PEDESTRAL_MONITOR = 'pedestral_monitor',
    POS_PRINTER_ESCPOS = 'pos_printer_escpos',
    POS_PRINTER_EPOS_XML = 'pos_printer_epos_xml',
    FILTERED_LIST_EXPORT = 'filtered_list_export',
    MULTILINGUALISM = 'multilingualism',
    DUAL_USE = 'dual_use',
}
